import React, { } from "react";
import Head from "./Head";
import Info from "./Info";
import "./index.scss";
const PlanBlock = ({ plan,_handlePlans }) => {
    return (
        <>
            <div className={`plan-block d-flex flex-column flex-fill ${plan?.active ? 'active' : ''}`}>
                <Head plan={plan} />
                <Info _active={plan?.active || false} plan={plan} _handlePlans={_handlePlans}/>
            </div>
        </>
    )
};
export default PlanBlock;